/**
 * DailyNest — Ghost Theme
 * Main JS bundle
 */

// Theme Configuration (Manage these here to save package.json custom settings)
window.dailynestConfig = {
    editionInfo: "VOL. IV · No 042", // Static edition string (fallback)
    autoEditionInfo: true,         // Set to true to calculate Vol/Issue from date
    siteStartYear: 2024            // Year publication started
};

// Site Information (Location & Edition)
(function () {
    var now = new Date();
    var config = window.dailynestConfig;

    // 1. Current Date
    var day = now.getDate();
    var month = now.toLocaleDateString('en-GB', { month: 'long' });
    var year = now.getFullYear();
    var customFormattedDate = day + " " + month + " · " + year;
    var shortFormattedDate = day + " " + month;

    document.querySelectorAll('.js-current-date').forEach(function(el) {
        el.textContent = customFormattedDate;
    });

    document.querySelectorAll('.js-current-date-short').forEach(function(el) {
        el.textContent = shortFormattedDate;
    });

    // 2. Edition Info Handling
    var editionElements = document.querySelectorAll('.site-edition-info');
    if (editionElements.length > 0) {
        if (config.autoEditionInfo) {
            function toRoman(num) {
                var map = { M: 1000, CM: 900, D: 500, CD: 400, C: 100, XC: 90, L: 50, XL: 40, X: 10, IX: 9, V: 5, IV: 4, I: 1 };
                var result = '';
                for (var i in map) {
                    while (num >= map[i]) {
                        result += i;
                        num -= map[i];
                    }
                }
                return result;
            }

            var volume = now.getFullYear() - (config.siteStartYear || 2024) + 1;
            var volRoman = toRoman(volume);
            var start = new Date(now.getFullYear(), 0, 0);
            var diff = (now - start) + ((start.getTimezoneOffset() - now.getTimezoneOffset()) * 60 * 1000);
            var oneDay = 1000 * 60 * 60 * 24;
            var dayOfYear = Math.floor(diff / oneDay);
            var issueNo = String(dayOfYear).padStart(3, '0');

            var fullText = "VOL. " + volRoman + " · No " + issueNo;
            editionElements.forEach(function(el) {
                el.textContent = fullText;
            });
        } else {
            editionElements.forEach(function(el) {
                el.textContent = config.editionInfo;
            });
        }
    }
})();

// Fullscreen overlay menu
(function () {
    var menu = document.getElementById('fullscreen-menu');
    var toggleDesktop = document.getElementById('menu-toggle-desktop');
    var close = document.getElementById('fullscreen-menu-close');
    if (!menu) return;

    function openMenu() {
        menu.classList.remove('hidden');
        menu.classList.add('menu-open-animate');
        menu.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
        document.body.style.overflow = '';
        menu.classList.remove('menu-open-animate');
        menu.setAttribute('aria-hidden', 'true');
        setTimeout(function () {
            menu.classList.add('hidden');
        }, 300);
    }

    if (toggleDesktop) toggleDesktop.addEventListener('click', openMenu);
    if (close) close.addEventListener('click', closeMenu);

    // Close on Escape
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !menu.classList.contains('hidden')) closeMenu();
    });

    // ── Live Digital Clock ──
    var clockEl = document.getElementById('menu-digital-clock');
    if (clockEl) {
        function updateClock() {
            var now = new Date();
            var hours = String(now.getHours()).padStart(2, '0');
            var minutes = String(now.getMinutes()).padStart(2, '0');
            var seconds = String(now.getSeconds()).padStart(2, '0');
            clockEl.textContent = hours + ":" + minutes + ":" + seconds;
        }
        updateClock();
        setInterval(updateClock, 1000);
    }

    // ── Timezone & GMT Offset ──
    var offsetEl = document.getElementById('menu-gmt-offset');
    if (offsetEl) {
        var offsetMin = new Date().getTimezoneOffset();
        var absOffset = Math.abs(offsetMin);
        var sign = offsetMin <= 0 ? '+' : '-';
        var hours = String(Math.floor(absOffset / 60)).padStart(2, '0');
        var mins = String(absOffset % 60).padStart(2, '0');
        offsetEl.textContent = "GMT" + sign + hours + ":" + mins;
    }
})();

// Mobile menu drawer
(function () {
    var menu = document.getElementById('mobile-menu');
    var drawer = document.getElementById('mobile-menu-drawer');
    var toggle = document.getElementById('mobile-menu-toggle');
    var close = document.getElementById('mobile-menu-close');
    if (!menu || !toggle) return;

    function openMenu() {
        menu.classList.remove('hidden');
        menu.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        
        // Force reflow so the transition applies
        void menu.offsetWidth;
        
        menu.classList.add('menu-open');
        if (drawer) {
            drawer.classList.remove('-translate-x-full');
            drawer.classList.add('translate-x-0');
        }
    }

    function closeMenu() {
        if (drawer) {
            drawer.classList.remove('translate-x-0');
            drawer.classList.add('-translate-x-full');
        }
        document.body.style.overflow = '';
        setTimeout(function () {
            menu.classList.add('hidden');
            menu.classList.remove('menu-open');
            menu.setAttribute('aria-hidden', 'true');
        }, 300);
    }

    toggle.addEventListener('click', openMenu);
    if (close) close.addEventListener('click', closeMenu);

    // Close on background click
    menu.addEventListener('click', function (e) {
        if (e.target === menu) closeMenu();
    });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !menu.classList.contains('hidden')) {
            closeMenu();
        }
    });
})();

// Reading progress
(function () {
    var bar = document.getElementById('reading-progress');
    if (!bar) return;
    var article = document.querySelector('.post-article');
    if (!article) return;

    var articleTop = 0;
    var articleHeight = 0;
    var total = 0;

    function measure() {
        var rect = article.getBoundingClientRect();
        var scrollTop = window.scrollY || document.documentElement.scrollTop;
        articleTop = rect.top + scrollTop;
        articleHeight = article.offsetHeight;
        total = articleHeight - window.innerHeight;
    }

    var ticking = false;

    function update() {
        var scrollTop = window.scrollY || document.documentElement.scrollTop;
        var relativeScroll = scrollTop - articleTop;
        var progress = Math.min(Math.max(relativeScroll / total, 0), 1);
        bar.style.width = (progress * 100) + '%';
        ticking = false;
    }

    window.addEventListener('scroll', function () {
        if (!ticking) {
            window.requestAnimationFrame(update);
            ticking = true;
        }
    }, { passive: true });

    window.addEventListener('resize', function () {
        measure();
        update();
    }, { passive: true });

    window.addEventListener('load', function () {
        measure();
        update();
    });

    measure();
    update();
})();

// Stacked card swiper (desktop split layout + mobile stacked)
(function () {
    function initSwiper(containerId, prevId, nextId, counterId, onSwipe) {
        var container = document.getElementById(containerId);
        var prev = document.getElementById(prevId);
        var next = document.getElementById(nextId);
        var counter = document.getElementById(counterId);
        if (!container || !prev || !next) return null;

        var cardClass = containerId === 'stacked-swiper-mobile' ? '.swiper-stack-card-mobile' : '.swiper-stack-card';
        var cards = Array.from(container.querySelectorAll(cardClass));
        if (!cards.length) return null;

        var VISIBLE = Math.min(4, cards.length);
        var ANIM_MS = 380;
        var SWIPE_THRESHOLD = 90;
        var isAnimating = false;
        var isDragging = false;
        var dragX = 0;
        var startX = 0;
        var startY = 0;
        var locked = null;

        function layoutCards() {
            cards.forEach(function (card, idx) {
                if (idx >= VISIBLE) { card.style.display = 'none'; return; }
                card.style.display = '';
                var baseScale = 1 - idx * 0.04;
                var baseY = idx * 18;
                var baseRotate = idx === 0 ? 0 : (idx % 2 === 1 ? -4 : 4);
                var baseX = idx === 0 ? 0 : (idx % 2 === 1 ? -12 : 12);
                card.style.zIndex = VISIBLE - idx;
                card.style.opacity = idx === VISIBLE - 1 ? '0.6' : '1';
                card.style.filter = idx > 0 ? 'brightness(' + (1 - idx * 0.06) + ') saturate(' + (1 - idx * 0.15) + ')' : 'none';

                if (idx === 0 && isDragging) {
                    card.style.transition = 'none';
                    card.style.transform = 'translate3d(' + dragX + 'px, 0, 0) rotate(' + (dragX / 18) + 'deg)';
                    card.style.opacity = 1 - Math.min(Math.abs(dragX) / 500, 0.25);
                    card.style.cursor = 'grabbing';
                    card.style.filter = 'none';
                } else {
                    card.style.transition = 'transform ' + ANIM_MS + 'ms cubic-bezier(0.22,1,0.36,1), opacity ' + ANIM_MS + 'ms ease';
                    card.style.transform = 'translate3d(' + baseX + 'px, ' + baseY + 'px, ' + (-idx * 40) + 'px) scale(' + baseScale + ') rotate(' + baseRotate + 'deg)';
                    card.style.cursor = idx === 0 ? 'grab' : '';
                }
            });
            if (counter) counter.textContent = 'p.' + String(parseInt(cards[0].dataset.index) + 1).padStart(3, '0');
        }

        function commitSwipe(dir) {
            if (isAnimating) return;
            isAnimating = true;
            var top = cards[0];
            top.style.transition = 'transform ' + ANIM_MS + 'ms cubic-bezier(0.22,1,0.36,1), opacity ' + ANIM_MS + 'ms ease';
            top.style.transform = 'translate3d(' + (dir * 600) + 'px, 0, 0) rotate(' + (dir * 30) + 'deg)';
            top.style.opacity = '0';
            setTimeout(function () {
                cards.push(cards.shift());
                top.style.transition = 'none';
                top.style.transform = '';
                top.style.opacity = '';
                dragX = 0;
                layoutCards();
                if (onSwipe) onSwipe(cards[0]);
                isAnimating = false;
            }, ANIM_MS);
        }

        container.addEventListener('touchstart', function (e) {
            if (isAnimating) return;
            startX = e.touches[0].clientX; startY = e.touches[0].clientY;
            locked = null; isDragging = true;
        }, { passive: true });

        container.addEventListener('touchmove', function (e) {
            if (!isDragging) return;
            var dx = e.touches[0].clientX - startX;
            var dy = e.touches[0].clientY - startY;
            if (!locked && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) locked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
            if (locked === 'x') { dragX = dx; layoutCards(); if (e.cancelable) e.preventDefault(); }
        }, { passive: false });

        container.addEventListener('touchend', function () {
            if (!isDragging) return;
            isDragging = false;
            if (Math.abs(dragX) > SWIPE_THRESHOLD) commitSwipe(dragX > 0 ? 1 : -1);
            else { dragX = 0; layoutCards(); }
        });

        container.addEventListener('mousedown', function (e) {
            if (isAnimating) return;
            e.preventDefault(); startX = e.clientX; isDragging = true;
        });

        window.addEventListener('mousemove', function (e) {
            if (!isDragging) return;
            dragX = e.clientX - startX; layoutCards();
        });

        window.addEventListener('mouseup', function () {
            if (!isDragging) return;
            isDragging = false;
            if (Math.abs(dragX) > SWIPE_THRESHOLD) commitSwipe(dragX > 0 ? 1 : -1);
            else { dragX = 0; layoutCards(); }
        });

        prev.addEventListener('click', function () { commitSwipe(-1); });
        next.addEventListener('click', function () { commitSwipe(1); });

        layoutCards();
        return { commitSwipe: commitSwipe, getTopCard: function () { return cards[0]; } };
    }

    // Desktop: update content panel on swipe
    function updateContentPanel(card) {
        var panel = document.getElementById('desktop-content-panel');
        if (!panel || !card) return;
        panel.style.opacity = '0';
        setTimeout(function () {
            var tag = document.getElementById('content-tag');
            var bar = document.getElementById('content-accent-bar');
            var title = document.getElementById('content-title');
            var excerpt = document.getElementById('content-excerpt');
            var author = document.getElementById('content-author');
            var avatar = document.getElementById('content-avatar');
            var initials = document.getElementById('content-avatar-initials');
            var date = document.getElementById('content-date');
            var readtime = document.getElementById('content-readtime');
            var link = document.getElementById('content-link');
            if (tag) tag.textContent = card.dataset.tag || '';
            if (bar) bar.style.backgroundColor = card.dataset.accent || 'var(--accent)';
            if (title) title.innerHTML = (card.dataset.title || '') + '<span class="font-black">.</span>';
            if (excerpt) excerpt.textContent = card.dataset.excerpt || '';
            if (author) author.textContent = card.dataset.author || '';
            
            // Handle Avatar vs Initials
            if (avatar && initials) {
                if (card.dataset.avatar) {
                    avatar.src = card.dataset.avatar;
                    avatar.classList.remove('hidden');
                    initials.classList.add('hidden');
                } else {
                    avatar.classList.add('hidden');
                    initials.classList.remove('hidden');
                    var nameParts = (card.dataset.author || '').trim().split(/\s+/);
                    var ini = "";
                    if (nameParts.length > 0) {
                        ini = nameParts[0][0];
                        if (nameParts.length > 1) ini += nameParts[nameParts.length - 1][0];
                    }
                    initials.textContent = ini || '?';
                }
            }

            if (date) date.textContent = card.dataset.date || '';
            if (readtime) readtime.textContent = card.dataset.readtime || '';
            if (link) link.href = card.dataset.url || '#';
            panel.style.opacity = '1';
        }, 150);
    }

    // Init desktop swiper
    var desktop = initSwiper('stacked-swiper', 'swiper-prev', 'swiper-next', 'swiper-counter', updateContentPanel);
    if (desktop) {
        updateContentPanel(desktop.getTopCard());
        window.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowLeft') desktop.commitSwipe(-1);
            if (e.key === 'ArrowRight') desktop.commitSwipe(1);
        });
    }

    // Init mobile swiper
    initSwiper('stacked-swiper-mobile', 'swiper-prev-mobile', 'swiper-next-mobile', 'swiper-counter-mobile', null);
})();

// Billing toggle
(function () {
    var toggle = document.getElementById('billing-toggle');
    if (!toggle) return;
    var buttons = toggle.querySelectorAll('button');
    var slider = toggle.querySelector('.slider');
    var prices = document.querySelectorAll('.monthly-price');

    function formatPrice(cents) {
        var dollars = cents / 100;
        if (dollars === Math.floor(dollars)) return '$' + Math.floor(dollars);
        return '$' + dollars.toFixed(2);
    }

    function switchPeriod(period) {
        buttons.forEach(function (btn, i) {
            var isActive = btn.dataset.period === period;
            btn.classList.toggle('active', isActive);
            if (isActive && slider) {
                slider.style.width = btn.offsetWidth + 'px';
                if (period === 'monthly') {
                    slider.style.left = '4px';
                } else {
                    // Yearly position = First button width + 4px padding
                    slider.style.left = (buttons[0].offsetWidth + 4) + 'px';
                }
            }
        });
        prices.forEach(function (el) {
            var monthly = parseInt(el.dataset.monthly);
            var yearly = parseInt(el.dataset.yearly);
            if (period === 'yearly' && yearly) {
                el.textContent = formatPrice(Math.round(yearly / 12));
            } else if (monthly) {
                el.textContent = formatPrice(monthly);
            }
        });
        // Update period labels
        document.querySelectorAll('.period-label').forEach(function (el) {
            el.textContent = period === 'yearly' ? 'per month (billed yearly)' : 'per month';
        });
        // Show/hide yearly savings
        document.querySelectorAll('.yearly-savings').forEach(function (el) {
            var priceEl = el.closest('article').querySelector('.monthly-price');
            if (!priceEl) return;
            var monthly = parseInt(priceEl.dataset.monthly);
            var yearly = parseInt(priceEl.dataset.yearly);
            if (period === 'yearly' && yearly && monthly) {
                var saved = (monthly * 12) - yearly;
                if (saved > 0) {
                    el.textContent = 'Save ' + formatPrice(saved) + '/year';
                    el.classList.remove('hidden');
                }
            } else {
                el.classList.add('hidden');
            }
        });
    }

    buttons.forEach(function (btn) {
        btn.addEventListener('click', function () { switchPeriod(btn.dataset.period); });
    });
    if (slider && buttons[0]) slider.style.width = buttons[0].offsetWidth + 'px';

    // Format prices on page load (Ghost stores in cents)
    switchPeriod('monthly');
})();

// View toggle (tag archive)
(function () {
    var toggleContainer = document.getElementById('view-toggle');
    var gridView = document.getElementById('grid-view');
    var listView = document.getElementById('list-view');
    if (!toggleContainer || !gridView || !listView) return;

    toggleContainer.querySelectorAll('.view-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
            var view = btn.dataset.view;
            toggleContainer.querySelectorAll('.view-btn').forEach(function (b) { b.classList.remove('active'); });
            btn.classList.add('active');
            gridView.classList.toggle('hidden', view !== 'grid');
            listView.classList.toggle('hidden', view !== 'list');
        });
    });
})();

// Auth flow
(function () {
    var signinForm = document.getElementById('signin-form');
    var signupForm = document.getElementById('signup-form');
    var checkEmail = document.getElementById('check-email');
    var emailDisplay = document.getElementById('check-email-address');
    var resendBtn = document.getElementById('resend-btn');
    var countdown = document.getElementById('resend-countdown');

    function showCheckEmail(email) {
        if (signinForm) signinForm.classList.add('hidden');
        if (signupForm) signupForm.classList.add('hidden');
        if (checkEmail) checkEmail.classList.remove('hidden');
        if (emailDisplay) emailDisplay.textContent = email;
        if (!resendBtn || !countdown) return;
        var seconds = 30;
        resendBtn.disabled = true;
        countdown.textContent = seconds;
        var timer = setInterval(function () {
            seconds--;
            countdown.textContent = seconds;
            if (seconds <= 0) { clearInterval(timer); resendBtn.disabled = false; resendBtn.textContent = 'Resend'; }
        }, 1000);
    }

    if (signinForm) {
        signinForm.addEventListener('submit', function () {
            var el = signinForm.querySelector('input[type="email"]');
            if (el) setTimeout(function () { showCheckEmail(el.value); }, 1000);
        });
    }
    if (signupForm) {
        signupForm.addEventListener('submit', function () {
            var el = signupForm.querySelector('input[type="email"]');
            if (el) setTimeout(function () { showCheckEmail(el.value); }, 1000);
        });
    }
})();

// Mixed-weight name splitting
// Renders last word of a name as bold italic, rest as light
(function () {
    var els = document.querySelectorAll('[data-split-name]');
    els.forEach(function (el) {
        var name = el.textContent.trim();
        if (!name) return;
        var parts = name.split(/\s+/);
        if (parts.length === 1) {
            el.innerHTML = '<span class="font-black italic">' + parts[0] + '</span>';
        } else {
            var last = parts.pop();
            el.innerHTML = parts.join(' ') + ' <span class="font-black italic">' + last + '</span>';
        }
    });
})();

// Accent word in titles
// Usage: add internal tag #accent-WordHere to a post
// The word will be styled bold+italic in the headline
(function () {
    var titles = document.querySelectorAll('[data-accent]');
    titles.forEach(function (el) {
        var tag = el.getAttribute('data-accent');
        if (!tag) return;
        var word = tag.replace(/^#?accent-/i, '');
        if (!word) return;
        var html = el.innerHTML;
        var idx = html.indexOf(word);
        if (idx === -1) return;
        var before = html.slice(0, idx);
        var after = html.slice(idx + word.length);
        el.innerHTML = before + '<span class="font-black italic">' + word + '</span>' + after;
    });
})();

// Reading Room tabs (Latest / Editor's Pick / Most Read)
(function () {
    var allTabs = document.querySelectorAll('.tab-btn');
    var allContents = document.querySelectorAll('.tab-content');
    if (!allTabs.length || !allContents.length) return;

    allTabs.forEach(function (btn) {
        btn.addEventListener('click', function () {
            var tab = btn.dataset.tab;

            // Update all tab buttons (desktop + mobile)
            allTabs.forEach(function (b) {
                var isActive = b.dataset.tab === tab;
                b.classList.toggle('active', isActive);
                if (isActive) {
                    b.classList.add('bg-stone-900', 'text-stone-50', 'border-[#1c1917]');
                    b.classList.remove('text-stone-700', 'border-transparent');
                } else {
                    b.classList.remove('bg-stone-900', 'text-stone-50', 'border-[#1c1917]');
                    b.classList.add('text-stone-700', 'border-transparent');
                }
            });

            // Show/hide content
            allContents.forEach(function (c) {
                c.classList.toggle('hidden', c.dataset.content !== tab);
            });
        });
    });
})();

// Dark/Light mode toggle
(function () {
    function toggleDark() {
        var isDark = document.documentElement.classList.toggle('dark');
        localStorage.setItem('dn-color-scheme', isDark ? 'dark' : 'light');
    }

    var btns = document.querySelectorAll('#theme-toggle, #theme-toggle-mobile, #theme-toggle-left, #theme-toggle-menu');
    btns.forEach(function (btn) {
        if (btn) btn.addEventListener('click', toggleDark);
    });

    // Listen for system changes when in "system" mode
    var scheme = document.documentElement.getAttribute('data-color-scheme');
    if (scheme === 'system' && !localStorage.getItem('dn-color-scheme')) {
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function (e) {
            if (!localStorage.getItem('dn-color-scheme')) {
                document.documentElement.classList.toggle('dark', e.matches);
            }
        });
    }
})();

// Subscriber count: base number + real members via API
(function () {
    var els = document.querySelectorAll('.subscriber-total, [data-count]');
    if (!els.length) return;

    // Try to get real member count from Ghost Members API
    fetch('/members/api/member/', { credentials: 'same-origin' })
        .then(function () {
            // Can't query member count via public API, use base only
            formatCounts(0);
        })
        .catch(function () {
            formatCounts(0);
        });

    function formatCounts(realMembers) {
        els.forEach(function (el) {
            var base = parseInt(el.dataset.count, 10) || 0;
            var total = base + realMembers;
            el.textContent = total.toLocaleString();
        });
    }

    // Initial format with base count
    formatCounts(0);
})();


// Header scroll shadow (dark mode aware)
(function () {
    var header = document.getElementById('site-header');
    if (!header) return;

    window.addEventListener('scroll', function () {
        header.classList.toggle('shadow-md', window.scrollY > 10);
    }, { passive: true });
})();

// Search system — handled by assets/js/modules/search.js

// Image Lightbox
(function () {
    document.addEventListener('DOMContentLoaded', function () {
        var images = document.querySelectorAll('.prose-mag img');
        if (!images.length) return;

        var modal = document.createElement('div');
        modal.id = 'lightbox-modal';
        modal.className = 'fixed inset-0 z-[200] hidden bg-black/90 flex items-center justify-center cursor-zoom-out opacity-0 transition-opacity duration-300';
        
        var img = document.createElement('img');
        img.className = 'max-w-[90%] max-h-[90vh] object-contain transition-transform duration-300 scale-95';
        
        modal.appendChild(img);
        document.body.appendChild(modal);

        images.forEach(function (image) {
            if (image.closest('a')) return;
            
            image.classList.add('cursor-zoom-in');
            image.addEventListener('click', function () {
                img.src = image.src;
                modal.classList.remove('hidden');
                void modal.offsetWidth;
                modal.classList.add('opacity-100');
                img.classList.remove('scale-95');
                img.classList.add('scale-100');
            });
        });

        function closeModal() {
            modal.classList.remove('opacity-100');
            img.classList.remove('scale-100');
            img.classList.add('scale-95');
            setTimeout(function () {
                modal.classList.add('hidden');
            }, 300);
        }

        modal.addEventListener('click', closeModal);
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && !modal.classList.contains('hidden')) {
                closeModal();
            }
        });
    });
})();

// Copy Code Button
(function () {
    document.addEventListener('DOMContentLoaded', function () {
        var preBlocks = document.querySelectorAll('.prose-mag pre');
        preBlocks.forEach(function (pre) {
            pre.style.position = 'relative';

            var button = document.createElement('button');
            button.className = 'copy-code-btn absolute top-3 right-3 px-2.5 py-1.5 text-[10px] font-bold uppercase tracking-wider text-stone-400 bg-stone-800/80 hover:bg-stone-800 hover:text-white border border-stone-700/50 rounded transition-all duration-150 cursor-pointer select-none';
            button.textContent = 'Copy';
            
            pre.appendChild(button);

            button.addEventListener('click', function () {
                var code = pre.querySelector('code');
                var text = code ? code.textContent : pre.textContent;
                
                navigator.clipboard.writeText(text).then(function () {
                    button.textContent = 'Copied!';
                    button.classList.add('text-emerald-400', 'border-emerald-500/50');
                    setTimeout(function () {
                        button.textContent = 'Copy';
                        button.classList.remove('text-emerald-400', 'border-emerald-500/50');
                    }, 2000);
                }).catch(function (err) {
                    console.error('Failed to copy text: ', err);
                });
            });
        });
    });
})();

// Back-to-Top Button
(function () {
    document.addEventListener('DOMContentLoaded', function () {
        var button = document.createElement('button');
        button.id = 'back-to-top';
        button.className = 'fixed bottom-6 right-6 w-10 h-10 bg-[var(--paper)] text-[var(--ink)] hover:text-[var(--accent)] border border-[var(--rule)] rounded-full flex items-center justify-center shadow-lg transition-all duration-300 opacity-0 invisible translate-y-4 hover:-translate-y-0.5 cursor-pointer z-50';
        button.setAttribute('aria-label', 'Back to top');
        
        button.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="18 15 12 9 6 15"/></svg>';
        document.body.appendChild(button);

        window.addEventListener('scroll', function () {
            if (window.scrollY > 300) {
                button.classList.remove('opacity-0', 'invisible', 'translate-y-4');
                button.classList.add('opacity-100', 'visible', 'translate-y-0');
            } else {
                button.classList.add('opacity-0', 'invisible', 'translate-y-4');
                button.classList.remove('opacity-100', 'visible', 'translate-y-0');
            }
        }, { passive: true });

        button.addEventListener('click', function () {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    });
})();

// Redirect Ghost Portal login/signup to custom signin/signup pages
(function () {
    // 1. Intercept hash changes on the parent window (standard Portal hash triggers)
    function handlePortalHash() {
        var hash = window.location.hash;
        if (hash.indexOf('portal/signup') !== -1) {
            window.location.hash = '';
            window.location.href = '/signup/';
        } else if (hash.indexOf('portal/signin') !== -1) {
            window.location.hash = '';
            window.location.href = '/signin/';
        }
    }
    window.addEventListener('hashchange', handlePortalHash);
    // Run on initial load in case page was loaded with portal hash
    handlePortalHash();

    // 2. Intercept Portal iframe insertion on parent page (covers postMessage triggers)
    function observePortalInsertion() {
        var observer = new MutationObserver(function (mutations) {
            var portalRoot = document.getElementById('ghost-portal-root');
            if (portalRoot) {
                var iframe = portalRoot.querySelector('iframe');
                if (iframe) {
                    var src = iframe.src || '';
                    if (src.indexOf('signup') !== -1 || window.location.hash.indexOf('signup') !== -1) {
                        portalRoot.remove(); // Hide the default portal popup immediately
                        window.location.hash = '';
                        window.location.href = '/signup/';
                    } else if (src.indexOf('signin') !== -1 || window.location.hash.indexOf('signin') !== -1) {
                        portalRoot.remove(); // Hide the default portal popup immediately
                        window.location.hash = '';
                        window.location.href = '/signin/';
                    }
                }
            }
        });
        
        observer.observe(document.documentElement, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', observePortalInsertion);
    } else {
        observePortalInsertion();
    }
})();

// Runway Spotlight Hero Slider
(function () {
    function initRunwaySlider() {
        var container = document.getElementById('runway-slider-container');
        var track = document.getElementById('runway-slider-track');
        var prevBtn = document.getElementById('runway-prev');
        var nextBtn = document.getElementById('runway-next');
        var dotsContainer = document.getElementById('runway-slider-dots');
        
        if (!container || !track) return;
        
        var slides = Array.from(track.querySelectorAll('.runway-slide'));
        if (slides.length <= 1) {
            if (prevBtn) prevBtn.style.display = 'none';
            if (nextBtn) nextBtn.style.display = 'none';
            if (dotsContainer) dotsContainer.style.display = 'none';
            return;
        }
        
        var dots = dotsContainer ? Array.from(dotsContainer.querySelectorAll('button')) : [];
        var currentIndex = 0;
        var totalSlides = slides.length;
        var autoPlayDelay = 5000;
        var autoPlayTimer = null;
        
        function updateSlider(index) {
            if (index < 0) index = totalSlides - 1;
            else if (index >= totalSlides) index = 0;
            
            currentIndex = index;
            track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
            
            dots.forEach(function (dot, i) {
                if (i === currentIndex) {
                    dot.classList.add('bg-white', 'scale-110');
                    dot.classList.remove('bg-white/20');
                } else {
                    dot.classList.remove('bg-white', 'scale-110');
                    dot.classList.add('bg-white/20');
                }
            });
        }
        
        function nextSlide() {
            updateSlider(currentIndex + 1);
        }
        
        function prevSlide() {
            updateSlider(currentIndex - 1);
        }
        
        function startAutoPlay() {
            stopAutoPlay();
            autoPlayTimer = setInterval(nextSlide, autoPlayDelay);
        }
        
        function stopAutoPlay() {
            if (autoPlayTimer) {
                clearInterval(autoPlayTimer);
                autoPlayTimer = null;
            }
        }
        
        if (prevBtn) {
            prevBtn.addEventListener('click', function () {
                prevSlide();
                startAutoPlay();
            });
        }
        
        if (nextBtn) {
            nextBtn.addEventListener('click', function () {
                nextSlide();
                startAutoPlay();
            });
        }
        
        dots.forEach(function (dot) {
            dot.addEventListener('click', function () {
                var index = parseInt(dot.getAttribute('data-slide-index'), 10);
                updateSlider(index);
                startAutoPlay();
            });
        });
        
        container.addEventListener('mouseenter', stopAutoPlay);
        container.addEventListener('mouseleave', startAutoPlay);
        
        var startX = 0;
        var isDragging = false;
        
        container.addEventListener('touchstart', function (e) {
            startX = e.touches[0].clientX;
            isDragging = true;
            stopAutoPlay();
        }, { passive: true });
        
        container.addEventListener('touchend', function (e) {
            if (!isDragging) return;
            isDragging = false;
            var endX = e.changedTouches[0].clientX;
            var diffX = endX - startX;
            
            if (Math.abs(diffX) > 50) {
                if (diffX > 0) {
                    prevSlide();
                } else {
                    nextSlide();
                }
            }
            startAutoPlay();
        }, { passive: true });
        
        updateSlider(0);
        startAutoPlay();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initRunwaySlider);
    } else {
        initRunwaySlider();
    }
})();


